'use es6';

import { Map as ImmutableMap } from 'immutable';
import ActionTypes from '../actions/ActionTypes';
const INITIAL_STATE = ImmutableMap({
  isRequestingProgressTransfer: false,
  isVerifyingProgressTransfer: false,
  hasError: false,
  progressTransferRequestCompleted: false,
  progressTransferVerified: false,
  recentError: undefined
});
export default function ProgressTransfer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ActionTypes.PROGRESS_TRANSFER_REQUESTING:
      return state.merge({
        hasError: false,
        isRequestingProgressTransfer: true,
        progressTransferRequestCompleted: false
      });
    case ActionTypes.PROGRESS_TRANSFER_REQUEST_COMPLETION:
      return state.merge({
        isRequestingProgressTransfer: false,
        progressTransferRequestCompleted: true
      });
    case ActionTypes.PROGRESS_TRANSFER_REQUEST_ERROR:
      return state.merge({
        isRequestingProgressTransfer: false,
        hasError: true,
        recentError: action.payload
      });
    case ActionTypes.VERIFY_PROGRESS_TRANSFER_REQUESTING:
      return state.merge({
        hasError: false,
        isVerifyingProgressTransfer: true,
        progressTransferVerified: false
      });
    case ActionTypes.VERIFY_PROGRESS_TRANSFER_SUCCESS:
      return state.merge({
        isVerifyingProgressTransfer: false,
        progressTransferVerified: true
      });
    case ActionTypes.VERIFY_PROGRESS_TRANSFER_ERROR:
      return state.merge({
        hasError: true,
        isVerifyingProgressTransfer: false,
        recentError: action.payload
      });
    default:
      return state;
  }
}